import React from 'react';
import { useParams } from 'react-router-dom';
import Event from './Event';

export default function EventRoute() {
  const { id } = useParams();
  return <Event key={id || 'new'} />;
}
